import { useEffect, useState } from "react";

const ReceivedOfferCounter = ({ cost, nextStep, closeWindow, counterData, setCounterData }) => {
  const { amount, days, hours } = counterData;
  const [isSubmitDisabled, setIsSubmitDisabled] = useState(true);


  useEffect(() => {
    if (typeof counterData.amount === 'number') {
      setCounterData(prev => ({
        ...prev,
        amount: counterData.amount === 0 ? "0.00" : counterData.amount.toFixed(2)
      }));
    }
  }, []);


  const getNumericValue = (str) => {
    if (!str || typeof str !== 'string') return NaN;
    const normalized = str.trim().replace(/,/g, '.');
    return parseFloat(normalized);
  };

  const onInputHandler = (e, max) => {
    const { name, value } = e.target;

    if (name === 'amount') {

      let cleanedValue = value.replace(/[^0-9.,]/g, '');
      const parts = cleanedValue.split(/[,\.]/);


      if (parts.length > 2 || (parts.length === 2 && parts[1].length > 2)) {
        return;
      }

      if (cleanedValue === '') {
        setCounterData(prev => ({ ...prev, amount: "" }));
        return;
      }


      setCounterData(prev => ({ ...prev, amount: cleanedValue }));
      return;
    }


    let cleanedValue = value.replace(/[^0-9]/g, '');
    if (cleanedValue === '') {
      setCounterData(prev => ({ ...prev, [name]: null }));
      return;
    }

    const num = Number(cleanedValue);
    if (num > max) {
      setCounterData(prev => ({ ...prev, [name]: max }));
    } else {
      setCounterData(prev => ({ ...prev, [name]: num }));
    }
  };

  const handleAmountBlur = () => {
    if (!amount || amount.trim() === '') {
      setCounterData(prev => ({ ...prev, amount: "" }));
      return;
    }

    const num = getNumericValue(amount);
    if (isNaN(num)) {
      setCounterData(prev => ({ ...prev, amount: "" }));
      return;
    }

    setCounterData(prev => ({ ...prev, amount: num.toFixed(2) }));
  };

  const isDisabledSubmitCheck = () => {
    const numAmount = getNumericValue(amount);
    const isAmountValid = !isNaN(numAmount) && numAmount > 0;
    const areTimeValid =
      (days !== null || hours !== null) &&
      !(days === 0 && hours === 0) &&
      !((days === null || days === '') && (hours !== null && hours !== '')) &&
      !((hours === null || hours === '') && (days !== null && days !== ''));

    setIsSubmitDisabled(!isAmountValid || !areTimeValid);
  };

  useEffect(() => {
    isDisabledSubmitCheck();
  }, [counterData]);

  return (
    <div className='make-offer__container'>
      <p className="make-offer__balance">
        <span>Amount Offered</span>
        <b>${cost.toFixed(2)} USD</b>
      </p>
      <div className="make-offer__form-row">
        <label>Your offer</label>
        <p className="make-offer__input-wrapper">
          <input
            type="text"
            name="amount"
            onInput={(e) => onInputHandler(e, Infinity)}
            onBlur={handleAmountBlur}
            placeholder="Offer value"
            value={amount || ""}
          />
          <span>USD</span>
        </p>
      </div>
      <div className="make-offer__form-row make-offer__form-row--double">
        <label>Offer valid for</label>
        <p className="make-offer__input-wrapper">
          <input
            type="number"
            name="days"
            onInput={(e) => onInputHandler(e, 30)}
            placeholder="1-30"
            value={days ?? ''}
          />
          <span>DAYS</span>
        </p>
        <p className="make-offer__input-wrapper">
          <input
            type="number"
            name="hours"
            onInput={(e) => onInputHandler(e, 23)}
            placeholder="1-23"
            value={hours ?? ''}
          />
          <span>HOURS</span>
        </p>
      </div>
      <footer className="sell-card__info-offer-options">
        <button onClick={closeWindow}>Cancel</button>
        <button className='accept' disabled={isSubmitDisabled} onClick={() => nextStep('confirm-counter')}>
          Continue
        </button>
      </footer>
    </div>
  );
};

export default ReceivedOfferCounter;

// import { useEffect, useState } from "react"

// const ReceivedOfferCounter = ({ cost, nextStep, closeWindow, counterData, setCounterData }) => {

//   const {amount, days, hours} = counterData;
//   const [isSubmitDisabled, setIsSubmitDisabled] = useState();

//   const onInputHandler = (e, max) => {
//     const { name, value } = e.target;

//     let cleanedValue = value.replace(/[^0-9.,]/g, '');

//     if (name === 'amount') {
//       const decimalParts = cleanedValue.split(/[,\.]/);
//       if (decimalParts.length > 2 || (decimalParts.length === 2 && decimalParts[1].length > 2)) {
//         return;
//       }
//     }


//     if (cleanedValue === '') {
//       setCounterData((prevData) => ({
//         ...prevData,
//         [name]: null
//       }));
//       return;
//     }

//     const numericValue = Number(cleanedValue.replace(',', '.'));

//     if (numericValue > max) {
//       setCounterData((prevData) => ({
//         ...prevData,
//         [name]: max
//       }));
//       return;
//     }


//     setCounterData((prevData) => ({
//       ...prevData,
//       [name]: numericValue
//     }));
//   };

// const isDisabledSubmitCheck = () => {
//   setIsSubmitDisabled(
//     (amount === null || amount === 0)
//     ||
//     (
//       (days !== null || days !== 0) && hours === null
//     )
//     ||
//     (
//       (hours !== null || hours !== 0) && days === null
//     )
//     ||
//     (days === 0 && hours === 0)
//   );
// };

// useEffect(() => {
//   isDisabledSubmitCheck()
// }, [counterData])

//   return (
//     <div className='make-offer__container'>
//       <p className="make-offer__balance">
//         <span>Amount Offered</span>
//         <b>${cost.toFixed(2)} USD</b>
//       </p>
//       <div className="make-offer__form-row">
//         <label>Your offer</label>
//         <p className="make-offer__input-wrapper">
//           <input type="number" name='amount' onInput={onInputHandler} placeholder="Offer value"  value={amount} />
//           <span>USD</span>
//         </p>
//       </div>
//       <div className="make-offer__form-row make-offer__form-row--double">
//         <label>Offer valid for</label>
//         <p className="make-offer__input-wrapper">
//           <input type="number" name="days" onInput={onInputHandler} placeholder="1-30" value={days} />
//           <span>DAYS</span>
//         </p>
//         <p className="make-offer__input-wrapper">
//           <input type="number" name="hours" onInput={onInputHandler} placeholder="1-23" value={hours} />
//           <span>HOURS</span>
//         </p>
//       </div>
//       <footer className="sell-card__info-offer-options">
//         <button onClick={closeWindow}>Cancel</button>
//         <button className='accept' disabled={isSubmitDisabled} onClick={() => nextStep('confirm-counter')}>Continue</button>
//       </footer>
//     </div>
//   )
// }

// export default ReceivedOfferCounter;
